"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = ViewGrid;
var _ViewGrid = require("@adobe/react-spectrum-workflow/dist/ViewGrid.js");
var _icon = require("@react-spectrum/icon");
var _react = _interopRequireDefault(require("react"));
function ViewGrid(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_ViewGrid.A4uViewGrid, null));
}